import { Box } from "@mui/material";

export interface SpanBoxProps {
    children: any;
    fontSize?: string | number;
}

function SpanBox(props: SpanBoxProps) {
    return (
        <Box
            component={"span"}
            sx={(theme) => ({
                whiteSpace: "break-spaces",
                fontSize: theme.typography.pxToRem(props.fontSize ? Number.parseInt(props.fontSize.toString()) : 13),
            })}
        >
            {props.children}
        </Box>
    );
}

export default SpanBox;
